"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var random = require("./random");
// spec: three digits between 002-899. 900-999 used for temporal ssns
// female: even
// male: odd
var Nnn = /** @class */ (function () {
    function Nnn(value) {
        var _this = this;
        this.value = value;
        this.isFemale = function () { return Nnn.isFemale(_this.value); };
        this.isMale = function () { return Nnn.isMale(_this.value); };
        this.isTemporal = function () { return Nnn.isTemporal(_this.value); };
        this.toString = function () { return ('00' + _this.value).slice(-3); };
    }
    Nnn.parse = function (s) {
        var i = parseInt(s, 10);
        if (Nnn.isReal(i) || Nnn.isTemporal(i))
            return new Nnn(i);
        throw new Error("Invalid nnn: " + s);
    };
    Nnn.gen = function (start, end) {
        return function (gender) {
            while (true) {
                var candidate = random.fromRange(start, end);
                switch (gender) {
                    case Gender.Female:
                        if (Nnn.isFemale(candidate))
                            return new Nnn(candidate);
                        continue;
                    case Gender.Male:
                        if (Nnn.isMale(candidate))
                            return new Nnn(candidate);
                        continue;
                }
            }
        };
    };
    Nnn.generate = Nnn.gen(2, 899);
    Nnn.generateTemporal = Nnn.gen(900, 999);
    Nnn.isFemale = function (x) { return x % 2 === 0; };
    Nnn.isMale = function (x) { return x % 2 !== 0; };
    Nnn.isReal = function (x) { return 2 <= x && x <= 899; };
    Nnn.isTemporal = function (x) { return 900 <= x && x <= 999; };
    return Nnn;
}());
exports.Nnn = Nnn;
var Gender;
(function (Gender) {
    Gender[Gender["Female"] = 0] = "Female";
    Gender[Gender["Male"] = 1] = "Male";
})(Gender = exports.Gender || (exports.Gender = {}));
//# sourceMappingURL=nnn.js.map